import React from "react";

export default function AccordionSection({
  sectionId,
  openSection,
  onOpenSection,
  title,
  className = "methodAccordionItem",
  panelClassName = "methodAccordionPanel",
  triggerClassName = "methodAccordionTrigger",
  children,
}) {
  const expanded = openSection === sectionId;

  return (
    <div className={`${className} ${expanded ? "open" : ""}`.trim()}>
      <button
        type="button"
        className={triggerClassName}
        aria-expanded={expanded}
        onClick={() =>
          onOpenSection((current) => (current === sectionId ? "" : sectionId))
        }
      >
        {title}
      </button>
      {expanded && <div className={panelClassName}>{children}</div>}
    </div>
  );
}
